import React from 'react'

import { PaddingBottomProps } from 'styled-system'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { HomePageQuery } from 'GraphQL/DatoCMS/TypedDocuments'

import { Container, Grid, StyledImage } from './styles'

type Props = PaddingBottomProps & {
  data?: HomePageQuery
}

function OurPartnersSection({ data, ...rest }: Props) {
  if (!data?.homePage?.partner) return null

  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Container {...rest} pt={[54, 54, 80]} px={LANDING_CONTENT_PX}>
          <SubsectionTitle centered title="Our Partners" />

          <Grid>
            {data.homePage.partner.map(item => (
              <StyledImage
                alt={item.logo?.alt}
                key={item.id}
                src={item.logo?.url}
              />
            ))}
          </Grid>
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default OurPartnersSection
